// src/components/admin/scheduling/components/SessionNoteTooltip.js
import React from "react";
import ReactDOM from "react-dom";

const tooltipStyles = {
  position: "fixed",
  zIndex: 99999,
  backgroundColor: "#333",
  color: "#fff",
  padding: "8px 12px",
  borderRadius: "6px",
  fontSize: "12px",
  lineHeight: "1.4",
  maxWidth: "250px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  pointerEvents: "none", // Allows clicks to pass through to the card if needed
  whiteSpace: "pre-wrap", // Preserves line breaks in notes
  transform: "translateY(10px)", // Small offset
};

export default function SessionNoteTooltip({ note, anchorRect, isVisible }) {
  if (!isVisible || !note || !anchorRect) return null;

  // Calculate position: Center aligned below the card
  // If near bottom of screen, flip to top (basic bounds checking)
  const isNearBottom = window.innerHeight - anchorRect.bottom < 150;
  
  const top = isNearBottom 
    ? anchorRect.top - 10 // Above
    : anchorRect.bottom;  // Below

  const left = anchorRect.left;
  
  // Render into body to escape any overflow:hidden containers
  return ReactDOM.createPortal(
    <div
      style={{
        ...tooltipStyles,
        top: top,
        left: left,
        transform: isNearBottom ? "translateY(-100%) translateY(-10px)" : "translateY(0)",
      }}
    >
      <strong>Note:</strong>
      <div style={{ marginTop: "4px", fontWeight: 400, opacity: 0.9 }}>
        {note}
      </div>
    </div>,
    document.body
  );
}